import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=2fac03aa&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fac03aa')) {
      api.createRecord('2fac03aa', component.options)
    } else {
      api.reload('2fac03aa', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=2fac03aa&", function () {
      api.rerender('2fac03aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/contact/Show.vue"
export default component.exports